// extracted by mini-css-extract-plugin
module.exports = {"createGame":"Form_createGame__24djc","form":"Form_form__21zRh","p":"Form_p__1vDyD","danger":"Form_danger__1NvYV","div":"Form_div__Bh63l"};